import React from 'react'

const ProgressBar = ({ done }) => {


    return (
        <div className="progress_container">
            <div className="progress">
                <div className="progress-bar progress-bar-striped bg-info progress-bar-animated" role="progressbar" style={{ width: `${done}%`}} aria-valuenow={done} aria-valuemin="0" aria-valuemax={done}>
                    {done}%
                </div>
            </div>
        </div>

    )
}

export default ProgressBar